import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ViewAiInsightsStatic = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main_title">
        <h1>AI Insight Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/ai-insights")}>AI Insights</button>{" "}
          - View Insight
        </p>
      </div>

      <div className="cards ai_view_container">
        {/* ---------- HEADER ---------- */}
        <div className="ai_view_header_new">
          <div className="ai_icon_circle">
            <img src="/static/images/placeholder.png" alt="icon" />
          </div>
          <div>
            <h2>Free Shipping Threshold Strategy</h2>
            <p className="ai_description_top">
              Analysis shows 12 checkouts abandoned at shipping page with avg
              cart value AED 95. Setting free shipping at AED 150 can
              significantly reduce drop-offs and increase order value.
            </p>
            <span
              className="priority_badge"
              style={{ background: "#d32f2f" }} // High tier color
            >
              HIGH
            </span>
          </div>
        </div>

        {/* ---------- AI Recommendation Box ---------- */}
        <div className="ai_recommend_box_new">
          <div className="ai_recommend_icon">
            <img src="/static/images/bulb_icon.svg" alt="bulb" />
          </div>
          <div>
            <h4>AI Recommendation</h4>
            <p>Implement free shipping for orders above AED 150</p>
          </div>
        </div>

        {/* ---------- METRIC BOXES ---------- */}
        <div className="ai_metrics_row">
          <div className="metric_box red_box">
            <span className="metric_icon">✖</span>
            <h2>12</h2>
            <p>Lost Checkouts</p>
          </div>

          <div className="metric_box blue_box">
            <span className="metric_icon">$</span>
            <h2>AED 95</h2>
            <p>Avg Cart Value</p>
          </div>

          <div className="metric_box green_box">
            <span className="metric_icon">$</span>
            <h2>AED 150</h2>
            <p>Free Shipping Threshold</p>
          </div>
        </div>

        {/* ---------- PROFIT IMPACT BOX ---------- */}
        <div className="profit_box">
          <h3>Profit Impact Calculator</h3>

          <div className="profit_row">
            <p>Avg shipping cost per order:</p>
            <span>AED 25</span>
          </div>

          <div className="profit_row">
            <p>Expected order increase:</p>
            <span style={{ color: "#3fa576" }}>+28%</span>
          </div>

          <div className="profit_row total_row">
            <p>Net profit impact:</p>
            <span style={{ color: "#1a8a34" }}>+AED 1,250/month</span>
          </div>
        </div>

        {/* ---------- CTA BUTTON ---------- */}
        <div className="ai_cta_row mt_20">
          <Button
            className="btn btn_primary"
            onClick={() => alert("Implement clicked")}
          >
            🚀 Implement This Recommendation
          </Button>

          <button className="icon_btn" onClick={() => alert("Liked!")}>
            👍
          </button>
        </div>
      </div>
    </>
  );
};

export default ViewAiInsightsStatic;
